import React from 'react';
import Chip from '@mui/material/Chip';
import { STUDENT_STATUSES, COHORT_STATUSES } from '../../utils/constants';

export default function StatusChip({ status, kind = 'student', size = 'small' }) {
  const map = kind === 'cohort' ? COHORT_STATUSES : STUDENT_STATUSES;
  const config = map[status];
  const label = config?.label || (status ? String(status).replace(/_/g, ' ') : 'Unknown');
  const color = config?.color || '#6b7280';

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: `${color}18`,
        color,
        fontWeight: 600,
        borderColor: `${color}40`,
        border: '1px solid',
        textTransform: 'capitalize',
      }}
    />
  );
}
